import { mdiThumbUp, mdiThumbUpOutline } from '@mdi/js'
import Icon from '@mdi/react'
import type { IconProps } from '.'

const Recommendation = (props: IconProps) => {
    const { filled = false, ...other } = props
    return (
        <Icon
            data-testid="IconButton__Recommendation"
            path={filled ? mdiThumbUp : mdiThumbUpOutline}
            size={1}
            {...other}
        />
    )
}

export default Recommendation
